import React from "react";
import {
  BlockerContainer,
  BlockerImage,
  BlockerTextWrapper,
  TextDesc,
  TextTitle,
  ButtonGroup
} from "./exit-blocker.styles";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import ExitConfirmImage from "public/assets-v2/illustrations/exit_confirmation.svg";

interface ExitBlockerProps {
  onContinue: () => void;
  onExit: () => void;
}

export const ExitBlocker: React.FC<ExitBlockerProps> = ({
  onContinue,
  onExit
}) => {
  return (
    <BlockerContainer>
      <BlockerImage src={ExitConfirmImage} alt="" />
      <BlockerTextWrapper>
        <TextTitle>Jangan nyerah dulu, lanjut latihan yuk!</TextTitle>
        <TextDesc>
          Kamu sudah hampir selesai, nih! Ayo lanjut sampai habis 💪
        </TextDesc>
      </BlockerTextWrapper>

      <ButtonGroup>
        <Button
          appearance="general"
          variant="primary"
          isFullWidth={true}
          size={ButtonSize.lg}
          onClick={onContinue}
        >
          Ayo lanjut!
        </Button>
        <Button
          appearance="general"
          variant="secondary"
          isFullWidth={true}
          size={ButtonSize.lg}
          onClick={onExit}
        >
          Keluar
        </Button>
      </ButtonGroup>
    </BlockerContainer>
  );
};
